import React from 'react'

import Collapsible from "react-collapsible";

import General from '../utils/General'

import LayoutEditor from "./LayoutEditor";
import Border from "./Border";
import Dropdown from "./Dropdown";
import ColorPicker from "./ColorPicker";
import IconPickerGrid from "./IconPickerGrid";

import Toggle from "./sectioninputs/Toggle";

import PortalModal from "./modal/PortalModal";
import DefaultData from "../utils/DefaultData";

const OPTIONS_BORDER_RADIUS = [
  { label: 'Square', value: '0px' },
  { label: 'Rounded', value: '6px' }
];
const OPTIONS_DISCOUNT= [
  { label: 'Amount', value: 'price' },
  { label: 'Percentage', value: 'percent' },
  { label: 'Amount & Percentage', value: 'both' },
]

export default class ProductDetailSettings extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      data: props.data,
    }

  }

  componentDidMount() {

  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  handleLayoutUpdate = (layoutOrder) => {
    const {data} = this.state;
    if (!data) {
      return;
    }

    data.layoutOrder = layoutOrder;
    this.setState({layoutOrder}, () => {
      this.props.onUpdated(data);
      setTimeout(() => General.updateAll(), 300);
    });
  };

  _renderLayoutPreviewUI() {
    let { data } = this.state
    return (
      <LayoutEditor
        title={"Page Layout"}
        layout={data.layoutOrder || [...DefaultData.PRODUCT_PAGE_LAYOUT]}
        onChange={this.handleLayoutUpdate}
        defaultLayout={[...DefaultData.PRODUCT_PAGE_LAYOUT]}
        onReset={() => {
          this.setState({showResetLayoutModal: true});
        }}
      />
    );
  }

  handleAutoPlayCarouselToggle = (checked) => {
    let { data } = this.state;
    data.autoplay_carousel_toggle = checked;
    const slider = window.flickityStore.mainSlider;
    if (!slider) return;

    checked ? slider.playPlayer() : slider.stopPlayer();
    this.props.onUpdated(data);
  };

  handleStickyLeftColumnToggle = (checked) => {
    const { data } = this.state;
    data.sticky_left_column = checked;
    this.setState({ data }, () => {
      this.props.onUpdated(data);
    });
  };

  _displaySettings() {
    let { data } = this.state
    let OPTIONS = [
      {
        value: "standard",
        label: "Standard"
      },
      {
        value: "even",
        label: "Even"
      }
    ]
    return (
      <Border>
        <Collapsible
          trigger={"Display"}
        >
          <br/>
          <span>Column Width</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value === (data.column_width || "standard")
            )}
            onChange={option => {
              data.column_width = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
          <br/>
          <Toggle
            id="autoplayToggle"
            title="Autoplay Carousel"
            checked={data?.autoplay_carousel_toggle}
            onChange={this.handleAutoPlayCarouselToggle}
          />
          <Toggle
            id="stickyLeftColumnToggle"
            title="Sticky Left Column"
            checked={data?.sticky_left_column}
            onChange={this.handleStickyLeftColumnToggle}
          />
        </Collapsible>
      </Border>
    )
  }

  _renderVariantSettings() {
    let {
      data
    } = this.state

    let imgTileVariantType = ""

    const variantTypeIndexes = [1, 2, 3]

    variantTypeIndexes.forEach((item) => {
      const key = `variant${item}_style`
      if (data[key] === "img_tile") {
        imgTileVariantType = key
      }
    })

    return (
      <Border>
        <Collapsible
          trigger={"Variants"}
        >
          {this._renderVariantTilePriceDisplaySettings()}

          {this._renderColorType()}

          {this._renderVariantType(1, imgTileVariantType)}

          {this._renderVariantType(2, imgTileVariantType)}

          {this._renderVariantType(3, imgTileVariantType)}
        </Collapsible>
      </Border>
    )
  }

  _renderVariantTilePriceDisplaySettings(){
    let { data } = this.state
    return (
      <>
        <br/>
        <Toggle
          id="toggle_variant_tile_price"
          checked={data.display_variant_tile_price}
          title="Display Prices On Variant"
          tooltip='Display prices on the last variant option when the variant type is set to "Button Vertical" and "Button Horizontal".'
          onChange={checked => {
            data.display_variant_tile_price = checked
            this.props.onUpdated(data)
          }}
        />
      </>
    )
  }

  _renderColorType(){
    let { data } = this.state
    let OPTIONS = [
      {
        value: "dropdown",
        label: "Dropdown Menu"
      },
      {
        value: "square",
        label: "Square Swatches"
      },
      {
        value: "circular",
        label: "Circular Swatches"
      },
      {
        value: "square_titles",
        label: "Square Swatches With Titles"
      },
      {
        value: "circular_titles",
        label: "Circular Swatches With Titles"
      },
      {
        value: "tiles",
        label: "Tiles"
      },
    ]
    return (
      <>
        <span>Color Swatch Style</span>
        <Dropdown
          options={OPTIONS}
          value={OPTIONS.find(
            (mode) => mode.value == data.color_picker_style
          )}
          onChange={option => {
            data.color_picker_style = option.value
            this.props.onUpdated(data)
          }}
          placeholder="Select An Option"
        />
      </>
    )
  }

  _renderVariantType(value, imgTileVariantType){
    let { data } = this.state

    let key = `variant${value}_style`

    let OPTIONS = [
      {
        value: "dropdown",
        label: "Dropdown Menu"
      },
      {
        value: "btn_horizontal",
        label: "Button Horizontal"
      },
      {
        value: "btn_vertical",
        label: "Button Vertical"
      }
    ]

    const imageTileVariantOptionSelected = imgTileVariantType === key

    if (imageTileVariantOptionSelected || !imgTileVariantType) {
      OPTIONS.push({
        value: "img_tile",
        label: "Image Tile"
      })
    }
    return (
      <>
          <br/>
          <span>Variant {value} Style</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value == data[key]
            )}
            onChange={option => {
              data[key] = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
          {imageTileVariantOptionSelected && this._renderImageTileVariantOptions(value)}
      </>
    )
  }

  _renderImageTileVariantOptions(value){
    let { data } = this.state
    let OPTIONS = [
      {
        value: "left",
        label: "Left"
      },
      {
        value: "right",
        label: "Right"
      },
      {
        value: "top",
        label: "Top"
      },
      {
        value: "img-only",
        label: "Image Only"
      }
    ]
    return (
      <>
        <span>Variant {value} Image Position</span>
        <Dropdown
          options={OPTIONS}
          value={OPTIONS.find(
            (mode) => mode.value == (data.img_tile_position || "right")
          )}
          onChange={option => {
            data.img_tile_position = option.value
            this.props.onUpdated(data)
          }}
          placeholder="Select An Option"
        />
        {data.img_tile_position === "img-only" && this._renderImageOnlyTileAspectRatioOptions(value)}
      </>
    )
  }

  _renderImageOnlyTileAspectRatioOptions(value){
    let { data } = this.state
    let OPTIONS = [
      {
        value: "",
        label: "Default"
      },
      {
        value: "img-tile-ratio img-tile-ratio-1x1",
        label: "1x1"
      },
      {
        value: "img-tile-ratio img-tile-ratio-4x3",
        label: "4x3"
      },
      {
        value: "img-tile-ratio img-tile-ratio-16x9",
        label: "16x9"
      },
      {
        value: "img-tile-ratio img-tile-ratio-21x9",
        label: "21x9"
      }
    ]
    return (
      <>
        <span>Variant {value} Aspect Ratio</span>
        <Dropdown
          options={OPTIONS}
          value={OPTIONS.find(
            (mode) => mode.value == (data.img_only_aspect_ratio || "default")
          )}
          onChange={option => {
            data.img_only_aspect_ratio = option.value
            this.props.onUpdated(data)
          }}
          placeholder="Select An Option"
        />
      </>
    )
  }

  _renderAccordionIcons(iconTitle, iconKey) {
    const { data } = this.state
    return <>
      <span>{iconTitle}</span>
      <Collapsible trigger={iconTitle} className="mb-3">
        <br />
        <div className="row no-gutters align-items-center">
          <div className="col-auto">Current Icon : </div>
          <div className="col-auto pl-2">
            {
              data[iconKey] ?
                <>
                  <i
                    className={`${data[iconKey]}`}
                    style={{fontSize: 30}}
                  />
                </>
                :
                <>
                  <i className="stack-interface stack-menu" style={{fontSize: 30}}></i>
                </>
            }
          </div>
        </div>
        <div className="button-icon-picker mt-4">
          <IconPickerGrid
            columnWidth={110}
            className=""
            width={356}
            rowHeight={110}
            onSelected={(icon) => {
              if (icon.icon.startsWith("fa-")) {
                data[iconKey] = icon.icon
                this.props.onUpdated(data)
              } else {
                data[iconKey] = `icon icon--lg icon-${icon.name}`
                this.props.onUpdated(data)
              }
            }}
          />
        </div>
      </Collapsible>
    </>
  }

  _renderMetaFieldsSettings() {
    const { data } = this.state
    const OPTIONS = [
      {
        value: "tabs",
        label: "Tabs"
      },
      {
        value: "collapsible-list",
        label: "Collapsible List"
      }
    ]
    return (
      <Border>
        <Collapsible
          trigger="Metafields"
        >
          <br/>
          <span>Type</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value === data.meta_field_type
            )}
            onChange={option => {
              data.meta_field_type = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
          {data.meta_field_type === "collapsible-list" && <>
            { this._renderAccordionIcons("Open Icon", "collapsible_list_open_icon") }
            { this._renderAccordionIcons("Close Icon", "collapsible_list_close_icon") }
            <Toggle
              id="toggle_collapsible_list"
              checked={data.collapsible_list_toggle}
              title="Toggle List"
              onChange={checked => {
                data.collapsible_list_toggle = checked
                this.props.onUpdated(data)
              }}
            />
          </>}
        </Collapsible>
      </Border>
    )
  }

  _renderResetLayoutModal() {
    return (
      <PortalModal
        show={this.state.showResetLayoutModal}
        showAsSideMenu="false"
        onHide={() => this.setState({showResetLayoutModal: false})}
      >
        <div className="modal-share">
          <div className="modal-head">
            <h2 className="mb-0">Reset Layout</h2>
          </div>

          <div className="row modal-body">
            <div className="col-md-12">
              <h4>Are you sure you want to reset the layout to its default configuration?</h4>
            </div>
          </div>

          <div className="text-right modal-footer">
            <a
              className="btn type--uppercase"
              onClick={() => this.setState({showResetLayoutModal: false})}
            >
            <span className="btn__text">
              Cancel
            </span>
            </a>
            <a
              className="btn btn--primary type--uppercase"
              style={{
                background: "#fa6160",
                borderColor: "#fa6160"
              }}
              onClick={() => {
                this.setState({showResetLayoutModal: false});
                this.handleLayoutUpdate(this.defaultLayout);
              }}
            >
            <span className="btn__text">
              Reset Layout
            </span>
            </a>
          </div>
        </div>
      </PortalModal>
    );
  }

  _renderSubscribeAndSaveSettings() {
    const { subscribeAndSaveSettings, updateSubscribeAndSaveSettings } = this.props;
    const { settings } = this.state;
    return (
      <Border>
        <Collapsible trigger="Subscribe & Save">
          <br/>
          <ColorPicker
            title="Text color"
            color={subscribeAndSaveSettings.textColor}
            onColorSelected={(color) => updateSubscribeAndSaveSettings('textColor', color)}
          />
          <div className="mb-4">
            <ColorPicker
              title="Selected Text Color"
              color={subscribeAndSaveSettings.selectedTextColor}
              onColorSelected={(color) => updateSubscribeAndSaveSettings('selectedTextColor', color)}
            />
          </div>
          <div className="mb-4">
            <ColorPicker
              title="Background color"
              color={subscribeAndSaveSettings.backgroundColor}
              onColorSelected={(color) => updateSubscribeAndSaveSettings('backgroundColor', color)}
            />
          </div>
          <div className="mb-4">
            <ColorPicker
              title="Selected background color"
              color={subscribeAndSaveSettings.selectedBackgroundColor}
              onColorSelected={(color) => updateSubscribeAndSaveSettings('selectedBackgroundColor', color)}
            />
          </div>
          <div className="mb-4">
            <ColorPicker
              title="Border color"
              color={subscribeAndSaveSettings.borderColor}
              onColorSelected={(color) => updateSubscribeAndSaveSettings('borderColor', color)}
            />
          </div>
          <div className="mb-4">
            <ColorPicker
              title="Selected border color"
              color={subscribeAndSaveSettings.selectedBorderColor}
              onColorSelected={(color) => updateSubscribeAndSaveSettings('selectedBorderColor', color)}
            />
          </div>
          <div className="mb-3">
            <span className="d-block mb-2">Border Style</span>
            <Dropdown
              options={OPTIONS_BORDER_RADIUS}
              value={OPTIONS_BORDER_RADIUS.find(
                (opt) => opt.value === subscribeAndSaveSettings.borderStyle
              )}
              onChange={(option) => {
                updateSubscribeAndSaveSettings({
                  borderStyle: option.value,
                });
              }}
              placeholder="Select An Option"
            />
          </div>
          <div className="mb-3">
            <span className="d-block mb-2">Display options for savings</span>
            <Dropdown
              options={OPTIONS_DISCOUNT}
              value={OPTIONS_DISCOUNT.find(
                (opt) => opt.value === subscribeAndSaveSettings.discountFormat
              )}
              onChange={(option) => {
                updateSubscribeAndSaveSettings('discountFormat', option.value);
              }}
              placeholder="Select Discount Format"
            />
          </div>

          <div className="icon-toggle-section mt-5">
            <Toggle
              id="customIconToggle"
              title="Choose Custom Icon"
              checked={subscribeAndSaveSettings.useCustomIcon}
              onChange={(checked) => {
                if (!checked) {
                  updateSubscribeAndSaveSettings({
                    oneTimeIcon: '',
                    subscribeIcon: '',
                    useCustomIcon: false
                  });
                } else {
                  updateSubscribeAndSaveSettings('useCustomIcon', true);
                }
              }}
            />

            {subscribeAndSaveSettings.useCustomIcon && (
              <div className="tabs-container tabs--folder">
                <ul className="tabs subscribe-icon">
                  {[
                    { key: 'oneTime', label: 'One Time' },
                    { key: 'subscribe', label: 'Subscribe & Save' },
                  ].map(tab => (
                    <li
                      key={tab.key}
                      className={subscribeAndSaveSettings.activeIconTab === tab.key ? 'active' : ''}
                      onClick={() => updateSubscribeAndSaveSettings('activeIconTab', tab.key)}
                    >
                      <div className="tab__title">
                        <span>{tab.label}</span>
                      </div>
                    </li>
                  ))}
                </ul>

                <ul className="tabs-content">
                  {['oneTime', 'subscribe'].map(tabKey => (
                    <li
                      key={tabKey}
                      className={subscribeAndSaveSettings.activeIconTab === tabKey ? 'active' : ''}
                    >
                      <div className="tab__content">
                        <div className="icon-preview mb-3 text-center">
                          {subscribeAndSaveSettings[`${tabKey}Icon`] ? (
                            <i
                              className={subscribeAndSaveSettings[`${tabKey}Icon`]}
                              style={{ fontSize: 24 }}
                            />
                          ) : (
                            <span className="no-icon">No icon selected</span>
                          )}
                        </div>

                        <div className="icon-picker-grid">
                          <IconPickerGrid
                            columnWidth={110}
                            width={356}
                            rowHeight={110}
                            className="subscribe-icon-grp"
                            onSelected={(icon) => {
                              const iconClass = icon.icon.startsWith('fa-')
                                ? icon.icon
                                : `icon icon--lg icon-${icon.name}`;

                              const updatedKey = tabKey === 'oneTime'
                                ? 'oneTimeIcon'
                                : 'subscribeIcon';

                              updateSubscribeAndSaveSettings({
                                [updatedKey]: iconClass
                              });
                            }}
                          />
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </Collapsible>
      </Border>
    )
  }

  render(){
    let {
      data
    } = this.state

    let imgTileVariantType = ""

    const variantTypeIndexes = [1, 2, 3]

    variantTypeIndexes.forEach((item) => {
      const key = `variant${item}_style`
      if (data[key] === "img_tile") {
        imgTileVariantType = key
      }
    })

    return (
      <>
        {this._renderLayoutPreviewUI()}

        {this._displaySettings()}

        {this._renderVariantSettings()}

        {this._renderMetaFieldsSettings()}

        {this._renderResetLayoutModal()}

        {this._renderSubscribeAndSaveSettings()}
      </>
    )
  }
}
